import { useSession } from "@/components/providers/session";
import { useRouter } from "next/router";
import React, { Fragment, useEffect, useState } from "react";
import {format} from "date-fns/format";
import dynamic from "next/dynamic";
import {
  CalendarIcon,
  ChevronRightIcon,
  ChevronDownIcon,
} from "@heroicons/react/20/solid";
import {
  addMonths,
  endOfMonth,
  getMonth,
  isSameDay,
  startOfMonth,
  subWeeks,
} from "date-fns";
import { createDates } from "@/components/course-calendar";
import { Popover, Transition } from "@headlessui/react";
import Link from "next/link";
import classNames from "@/utils/classnames";
import { currency } from "@/utils/formats";
const CallbackModal = dynamic(() => import("@/components/callback-modal"));

export default function CourseDates({
  primary,
  dates,
  event,
  setSelectedDate: setDate,
}) {
  const [openTab, setOpenTab] = useState("in-person");
  const session = useSession();
  const router = useRouter();
  const [state, setState] = useState({
    selectedDate: null,
    selectedEvent: [],
    selectedType: null,
    current: new Date(),
    month: new Date(),
    imageUrl: null,
    monthEvents: [],
    allSelectedDates: [],
    expand: false,
    days: createDates(
      startOfMonth(new Date()),
      endOfMonth(new Date()),
      new Date()
    ),
  });

  const [showModal, setShowModal] = useState({
    showCallbackModal: false,
  });

  useEffect(() => {
    setState((s) => ({
      ...s,
      monthEvents: event.events,
    }));

    const date = new Date(event.events[0].date);

    let newMonth = getMonth(date);
    let currentMonth = getMonth(new Date());

    let difference = newMonth - currentMonth;
    setState((s) => {
      return {
        ...s,
        month: addMonths(state.month, difference),
        days: createDates(
          startOfMonth(addMonths(state.month, difference)),
          endOfMonth(addMonths(state.month, difference)),
          s.selectedDate
        ),
      };
    });
  }, []);

  useEffect(() => {
    try {
      setDate(state.selectedDate);
    } catch (err) {
      console.log(err);
    }
  }, [state.selectedDate]);

  const datesWithEvents = React.useMemo(() => {
    return (
      state &&
      state.days &&
      state.days.length > 0 &&
      state.days.map((day) => {
        return {
          ...day,
          hasEvent: event.events?.some((event) =>
            isSameDay(new Date(event.date), day.date)
          ),
          events: event.events?.filter((event) =>
            isSameDay(new Date(event.date), day.date)
          ),
        };
      })
    );
  }, [state.days, event.events, state.month, router.pathname]);

  useEffect(() => {
    datesWithEvents &&
    datesWithEvents.find((day) => {
      return day.hasEvent;
    })
      ? setState((s) => ({
          ...s,
          selectedDate: datesWithEvents.find((day) => {
            return day.hasEvent;
          }),
        }))
      : null;
  }, [datesWithEvents]);

  const filteredEvents = React.useMemo(
    () =>
      event.events &&
      event.events.length > 0 &&
      event.events?.filter((event) =>
        isSameDay(new Date(event.date), state?.selectedDate?.date)
      ),
    [event.events, state.selectedDate, router.pathname]
  );

  if (event && event.events.length === 0) {
    return null;
  }

  const copy = event && event.events ? [...event.events] : [];

  const virtualCollection =
    copy && copy.length > 0 ? copy.filter((x) => x.type === "virtual") : [];

  const blendedCollection =
    copy && copy.length > 0 ? copy.filter((x) => x.type === "blended") : [];

  const onsiteCollection =
    copy && copy.length > 0
      ? copy.filter(
          (x) => x.type === "onsite" && x.seats > x.registrations.length
        )
      : [];

  const shard =
    onsiteCollection && onsiteCollection.length > 0
      ? state.expand
        ? onsiteCollection
        : onsiteCollection.slice(0, 4)
      : [];

  return (
    <div>
      {/* <div className="flex flex-wrap mt-5">
        <div className="w-full px-10 md:px-6 max-w-7xl mx-auto">
          <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row space-y-3 md:space-y-0"
            role="tablist"
          >
            {onsiteCollection.length > 0 ? (
              <li className="-mb-px md:mr-2 last:mr-0 flex-auto text-center">
                <a
                  className={
                    "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                    (openTab === "in-person"
                      ? "text-black bg-brand-100"
                      : "text-brand-600 bg-white")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab("in-person");
                  }}
                  data-toggle="tab"
                  href="#link1"
                  role="tablist"
                >
                  In-person Training
                </a>
              </li>
            ) : null}
            {/* {virtualCollection.length > 0 && event.events.length <= 3 ? (
              <li className="-mb-px md:mr-2 last:mr-0 flex-auto text-center">
                <a
                  className={
                    "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                    (openTab === "virtual"
                      ? "text-black bg-brand-100"
                      : "text-brand-600 bg-white")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab("virtual");
                  }}
                  data-toggle="tab"
                  href="#link2"
                  role="tablist"
                >
                  Virtual Training
                </a>
              </li>
            ) : null}
            {blendedCollection.length > 0 && event.events.length <= 3 ? (
              <li className="-mb-px md:mr-2 last:mr-0 flex-auto text-center">
                <a
                  className={
                    "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                    (openTab === "blended"
                      ? "text-black bg-brand-100"
                      : "text-brand-600 bg-white")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab("blended");
                  }}
                  data-toggle="tab"
                  href="#link3"
                  role="tablist"
                >
                  Blended Training
                </a>
              </li>
            ) : null} 
          </ul>
        </div>
      </div> */}

      {/* {event.events.length <= 3 && ( */}
      <section id="course-dates" className="">
        <div
          className={openTab === "in-person" ? "block" : "hidden"}
          id="link1"
        >
          <div>
            <div className="relative max-w-screen">
              <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto text-center prose lg:prose-lg">
                  <div className="bg-white shadow sm:rounded-md mb-4 relative max-w-7xl mx-auto not-prose">
                    <ul
                      role="list"
                      className="divide-y divide-gray-200 list-none m-0 p-0 mt-4"
                    >
                      {shard &&
                        shard.map((ev, idx) => {
                          let enhanced = ev.detail && ev.detail.programme_id;
                          const startDate =
                            ev.settings && ev.settings.dates
                              ? new Date(ev.settings.dates[0].start)
                              : new Date(ev.start);

                          const end =
                            ev.settings && ev.settings.dates
                              ? new Date(
                                  ev.settings.dates[
                                    ev.settings.dates.length - 1
                                  ].end
                                )
                              : new Date(ev.end);

                          const assignmentsDue = enhanced
                            ? subWeeks(startDate, 2)
                            : null;

                          if (enhanced) {
                            console.log("assignmentsDue date", assignmentsDue);
                            console.log("start date", startDate);
                            console.log("end date", end);
                          }

                          const isDiscounted = !!ev?.discounted;

                          return (
                            <li
                              key={ev.id}
                              className="m-0 p-0 relative"
                              itemScope
                              itemProp="http://schema.org/Event"
                            >
                              <meta
                                itemProp="startDate"
                                content={format(
                                  new Date(startDate),
                                  "yyyy-MM-dd"
                                )}
                              />
                              <meta
                                itemProp="endDate"
                                content={format(end, "yyyy-MM-dd")}
                              />
                              <meta
                                itemProp="organizer"
                                content="Cosmetic College"
                              />
                              <meta
                                itemProp="eventStatus"
                                content="Scheduled"
                              />
                              <meta
                                itemProp="name"
                                content={primary.fields.title}
                              />
                              <meta
                                itemProp="description"
                                content={
                                  primary.fields.metadata.fields.description
                                }
                              />
                              <span
                                itemProp="performer"
                                itemScope
                                itemType="http://schema.org/Person"
                              >
                                <meta
                                  itemProp="name"
                                  content="Cosmetic Courses"
                                />
                              </span>
                              <meta
                                itemProp="maximumAttendeeCapacity"
                                content="6"
                              />
                              <meta
                                itemProp="maximumPhysicalAttendeeCapacity"
                                content="6"
                              />
                              <meta
                                itemProp="image"
                                content={
                                  primary.fields.metadata.fields.image.fields
                                    .file.url
                                }
                              />
                              <div
                                className="sr-only"
                                itemProp="location"
                                itemScope
                                itemType="http://schema.org/Place"
                              >
                                <meta itemProp="name" content="London" />
                              </div>
                              <div
                                className="sr-only"
                                itemProp="offers"
                                itemScope
                                itemType="http://schema.org/Offer"
                              >
                                <meta
                                  itemProp="name"
                                  content={primary.fields.title}
                                />
                                <meta itemProp="priceCurrency" content="GBP" />
                                <meta
                                  itemProp="price"
                                  content={(
                                    (ev.seat_price * 1.2) /
                                    100
                                  ).toFixed(0)}
                                />
                                <meta
                                  itemProp="availability"
                                  content={String(
                                    ev.seats -
                                      ev.countStudentRegistrations.aggregate
                                        .count
                                  )}
                                />
                                <meta
                                  itemProp="url"
                                  content={`https://cosmetic.college${primary.fields.url}`}
                                />
                                <meta
                                  itemProp="validFrom"
                                  content={format(
                                    new Date(startDate),
                                    "yyyy-MM-dd"
                                  )}
                                />
                              </div>
                              {primary && ev && (
                                <script
                                  type="application/ld+json"
                                  dangerouslySetInnerHTML={{
                                    __html: JSON.stringify({
                                      "@context": "https://schema.org",
                                      "@type": "Event",
                                      name: primary.fields.title,
                                      description:
                                        primary.fields.metadata.fields
                                          .description,
                                      image: `https:${primary.fields.metadata.fields.image.fields.file.url}`,
                                      startDate: format(
                                        new Date(startDate),
                                        "yyyy-MM-dd"
                                      ),
                                      endDate: format(end, "yyyy-MM-dd"),
                                      eventStatus:
                                        "https://schema.org/EventScheduled",
                                      eventAttendanceMode:
                                        "https://schema.org/OfflineEventAttendanceMode",
                                      location: {
                                        "@type": "Place",
                                        name: "Cosmetic College",
                                        address: {
                                          "@type": "PostalAddress",
                                          streetAddress: "3 Locks Court",
                                          addressLocality: "London",
                                          postalCode: "BR68NL",
                                          addressCountry: "GB",
                                        },
                                      },
                                      organizer: {
                                        "@type": "Organization",
                                        name: "Cosmetic College",
                                        url: "https://cosmetic.college",
                                      },
                                      offers: {
                                        "@type": "Offer",
                                        name: "Seat",
                                        price: (
                                          (ev.seat_price * 1.2) /
                                          100
                                        ).toFixed(0),
                                        priceCurrency: "GBP",
                                        validFrom: format(
                                          new Date(startDate),
                                          "yyyy-MM-dd"
                                        ),
                                        url: `https://cosmetic.college${primary.fields.url}?id=${ev.id}`,
                                        availability:
                                          "https://schema.org/InStock",
                                      },
                                    }),
                                  }}
                                />
                              )}

                              {ev.seats - ev.registrations.length > 0 ? (
                                <div
                                  className={classNames(
                                    "block hover:bg-gray-50 w-full relative focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600",
                                    isDiscounted
                                      ? "border-brand-600 border-2 rounded-xl"
                                      : ""
                                  )}
                                >
                                  {isDiscounted && ev.detail.standard_price ? (
                                    <div className="bg-brand-600 rounded-t-lg flex flex-row items-center justify-center font-semibold absolute text-xs px-2.5 py-1.5 left-4 -top-8 h-8 text-white">
                                      Last Minute Space Discount - Was{" "}
                                      {currency(ev.detail.standard_price)}
                                    </div>
                                  ) : null}
                                  <div className="flex items-center px-4 py-4 lg:px-6">
                                    <div className="min-w-0 flex-1 lg:flex lg:items-center lg:justify-between">
                                      <div className="text-center">
                                        <div className="flex w-full justify-center items-center lg:justify-start">
                                          <CalendarIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-brand-700"
                                            aria-hidden="true"
                                          />
                                          <p className="font-semibold text-brand-700 text-left">
                                            {format(
                                              new Date(startDate),
                                              "EEEE do MMMM"
                                            )}
                                          </p>
                                        </div>
                                        <div className="mt-2 flex w-full flex-wrap md:flex-nowrap">
                                          <div className="flex items-center text-sm text-gray-500 w-full justify-center lg:justify-start space-x-4">
                                            {startDate ? (
                                              <>
                                                <p className="w-44 lg:text-left">
                                                  {format(
                                                    new Date(startDate),
                                                    "p"
                                                  )}{" "}
                                                  -{" "}
                                                  {format(
                                                    new Date(ev.end),
                                                    "p"
                                                  )}
                                                </p>
                                              </>
                                            ) : null}
                                            <p className="flex-1 lg:w-48">
                                              {ev.seats -
                                                ev.registrations.length}{" "}
                                              space
                                              {/* Plural. */}
                                              {ev.seats -
                                                ev.registrations.length !==
                                                1 && "s"}{" "}
                                              available
                                            </p>
                                          </div>
                                          <div className="flex justify-center items-center w-full flex-1 mt-3 md:mt-0 md:flex-auto">
                                            {!isSameDay(
                                              new Date(startDate),
                                              end
                                            ) &&
                                            ev.settings &&
                                            ev.settings.dates &&
                                            ev.settings.dates.length > 0 ? (
                                              <Popover className="relative">
                                                {({ open }) => (
                                                  <>
                                                    <Popover.Button
                                                      className={`
                                                        ${
                                                          open
                                                            ? "text-gray-600"
                                                            : "text-gray-700"
                                                        }
                                                        group inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium hover:text-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 w-full`}
                                                    >
                                                      <span>
                                                        View Full Course
                                                        Schedule
                                                      </span>
                                                      <ChevronDownIcon
                                                        className={`${
                                                          open
                                                            ? "text-gray-600"
                                                            : "text-gray-700"
                                                        }
                                                          ml-2 h-5 w-5 transition duration-150 ease-in-out group-hover:text-gray-800`}
                                                        aria-hidden="true"
                                                      />
                                                    </Popover.Button>
                                                    <Transition
                                                      as={Fragment}
                                                      enter="transition ease-out duration-200"
                                                      enterFrom="opacity-0 translate-y-1"
                                                      enterTo="opacity-100 translate-y-0"
                                                      leave="transition ease-in duration-150"
                                                      leaveFrom="opacity-100 translate-y-0"
                                                      leaveTo="opacity-0 translate-y-1"
                                                    >
                                                      <Popover.Panel className="absolute left-1/2 mt-3 w-screen max-w-sm -translate-x-1/2 transform px-4 sm:px-0 z-40">
                                                        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5">
                                                          <div className="relative flex flex-col bg-white p-4">
                                                            <h3 className="font-semibold text-sm text-gray-800 mb-2">
                                                              Training Overview
                                                            </h3>
                                                            {assignmentsDue ? (
                                                              <div className="border rounded py-4 mb-4">
                                                                <p className="mt-2 font-semibold text-sm text-gray-800 mb-2">
                                                                  Pre Study
                                                                </p>
                                                                <p className="flex flex-col items-center px-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none">
                                                                  <span className="flex">
                                                                    <p className="text-sm font-medium text-gray-900">
                                                                      <span className="block">
                                                                        E
                                                                        learning
                                                                        and
                                                                        written
                                                                        assignments
                                                                        due:
                                                                      </span>
                                                                      {format(
                                                                        assignmentsDue,
                                                                        "EEEE do MMMM"
                                                                      )}
                                                                    </p>
                                                                  </span>
                                                                </p>
                                                              </div>
                                                            ) : null}
                                                            <div className="border rounded py-4">
                                                              <p className="mt-2 font-semibold text-sm text-gray-800 mb-2">
                                                                Practical
                                                                Training Dates
                                                              </p>
                                                              {ev.settings.dates.map(
                                                                (item) => (
                                                                  <p
                                                                    key={
                                                                      item.start
                                                                    }
                                                                    className="flex flex-col items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500/50"
                                                                  >
                                                                    <span className="flex">
                                                                      <p className="text-sm font-medium text-gray-900">
                                                                        {format(
                                                                          new Date(
                                                                            item.start
                                                                          ),
                                                                          "EEEE do MMMM p"
                                                                        )}{" "}
                                                                        -{" "}
                                                                        {format(
                                                                          new Date(
                                                                            item.end
                                                                          ),
                                                                          "p"
                                                                        )}
                                                                      </p>
                                                                    </span>
                                                                  </p>
                                                                )
                                                              )}
                                                            </div>

                                                            <Link href="/request-a-callback/"></Link>
                                                          </div>
                                                        </div>
                                                      </Popover.Panel>
                                                    </Transition>
                                                  </>
                                                )}
                                              </Popover>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mt-2 flex-shrink-0 lg:mt-0 lg:ml-5">
                                        <div className="flex flex-col lg:flex-row items-center">
                                          <p className="mb-2 lg:mb-0 font-semibold flex flex-col">
                                            {new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "GBP",
                                            }).format(ev.price / 100)}
                                            <span className="text-xs font-normal">
                                              excl VAT
                                            </span>
                                          </p>
                                          <button
                                            type="button"
                                            onClick={() => {
                                              session.addCourse({
                                                ...primary,
                                                event,
                                                selectedEvent: ev,
                                              });
                                              setTimeout(() => {
                                                router.push("/checkout");
                                              }, 500);
                                            }}
                                            className="my-4 w-full md:max-w-64 rounded-md bg-brand-600 px-6 py-4 text-sm font-semibold text-white shadow-sm hover:bg-brand-500 outline outline-2 outline-offset-2 outline-brand-600 gradient-border ml-4"
                                          >
                                            <span className="relative z-[1]">
                                              Book Training
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="hidden lg:block lg:ml-5 flex-shrink-0">
                                      <ChevronRightIcon
                                        className="h-5 w-5 text-gray-400"
                                        aria-hidden="true"
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                            </li>
                          );
                        })}
                      {onsiteCollection &&
                        onsiteCollection.length > 3 &&
                        !state.expand && (
                          <button
                            className="block hover:bg-gray-50 w-full focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600"
                            onClick={() => {
                              setState((s) => ({ ...s, expand: true }));
                            }}
                          >
                            <div className="flex items-center px-4 py-4 sm:px-6">
                              <div className="flex w-full justify-center items-center">
                                <CalendarIcon
                                  className="mr-1.5 h-5 w-5 flex-shrink-0 text-brand-700"
                                  aria-hidden="true"
                                />
                                <p className="truncate font-semibold text-brand-700">
                                  Show More Dates
                                </p>
                              </div>
                            </div>
                          </button>
                        )}
                    </ul>
                    {onsiteCollection &&
                      onsiteCollection.length > 3 &&
                      state.expand && (
                        <div className="border-t py-4">
                          <div className="max-w-lg mx-auto">
                            <p className="truncate font-semibold text-brand-700">
                              Need a different date?
                            </p>
                            <p className="text-gray-500 text-sm px-4">
                              Can&#39;t find a date that is suitable to train?
                              Contact us to discuss alternative dates we can set
                              up for you to train
                            </p>
                            <div className="mt-4 px-10 flex flex-col sm:flex-row justify-center items-center relative z-1 rounded-md flex-1">
                              <a
                                href="tel:+443330155117"
                                className="cursor-pointer whitespace-nowrap w-full flex items-center justify-center px-3 py-2 border border-transparent shadow text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 md:mr-4"
                              >
                                Call Us
                              </a>
                              {/* <button
                                type="button"
                                onClick={() => {
                                  setShowModal({
                                    ...state,
                                    showCallbackModal: true,
                                  });
                                }}
                                className="mt-4 sm:mt-0 sm:ml-2 md:ml-0 whitespace-nowrap md:mt-0 w-full flex items-center justify-center px-3 py-2 border border-brand-500 shadow text-sm font-medium rounded-md text-brand-600 bg-white hover:bg-gray-100"
                              >
                                Request a callback
                              </button> */}
                              <Link
                                href="/request-a-callback"
                                className="mt-4 sm:mt-0 sm:ml-2 md:ml-0 whitespace-nowrap md:mt-0 w-full flex items-center justify-center px-3 py-2 border border-brand-500 shadow text-sm font-medium rounded-md text-brand-600 bg-white hover:bg-gray-100"
                              >
                                Request a callback
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {virtualCollection.length > 0 && event.events.length <= 3 ? (
          <div
            className={openTab === "virtual" ? "block" : "hidden"}
            id="link2"
          >
            <div>
              <div className="relative">
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="max-w-7xl mx-auto text-center prose lg:prose-lg">
                    <p className="text-gray-500   my-3 p-2">
                      Our virtual training courses are delivered to students
                      through the use of Zoom webinars. These courses are
                      demonstrated and assessed via Zoom and are supplemented
                      with online learning modules. Accreditation will only be
                      complete once all course modules and parts are completed.
                    </p>

                    <div className="overflow-hidden bg-white shadow sm:rounded-md mb-4 relative max-w-7xl mx-auto not-prose">
                      <ul
                        role="list"
                        className="divide-y divide-gray-200 list-none m-0 p-0"
                      >
                        {virtualCollection &&
                          virtualCollection.map((ev, idx) => (
                            <li key={ev.id} className="m-0 p-0">
                              <button
                                className="block hover:bg-gray-50 w-full focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600"
                                onClick={() => {
                                  session.addCourse({
                                    ...primary,
                                    event,
                                    selectedEvent: ev,
                                  });
                                  setTimeout(() => {
                                    router.push("/checkout");
                                  }, 500);
                                }}
                              >
                                <div className="flex items-center px-4 py-4 sm:px-6">
                                  {ev.seats - ev.registrations.length < 1 ? (
                                    <div></div>
                                  ) : (
                                    <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                                      <div className="truncate text-center">
                                        <div className="flex w-full justify-center items-center">
                                          <CalendarIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-brand-700"
                                            aria-hidden="true"
                                          />
                                          <p className="truncate font-semibold text-brand-700">
                                            {format(
                                              new Date(ev.date),
                                              "EEEE do MMMM"
                                            )}
                                          </p>
                                        </div>
                                        <div className="mt-2 flex w-full">
                                          <div className="flex items-center text-sm text-gray-500 justify-center w-full md:justify-start">
                                            <p>
                                              {ev.seats -
                                                ev.registrations.length}{" "}
                                              space
                                              {/* Plural. */}
                                              {ev.seats -
                                                ev.registrations.length !==
                                                1 && "s"}{" "}
                                              available
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mt-2 flex-shrink-0 md:mt-0 md:ml-5">
                                        <div className="flex flex-col md:flex-row items-center">
                                          <p className="mb-2 md:mb-0 font-semibold">
                                            {new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "GBP",
                                            }).format(ev.price / 100)}
                                          </p>
                                          <div className="mt-2 md:mt-0 md:ml-4 w-full flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md text-gray-600 bg-gray-50 hover:bg-gray-100 border border-gray-200 hover:shadow transition-all duration-100">
                                            Book
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="hidden md:block md:ml-5 flex-shrink-0">
                                    <ChevronRightIcon
                                      className="h-5 w-5 text-gray-400"
                                      aria-hidden="true"
                                    />
                                  </div>
                                </div>
                              </button>
                            </li>
                          ))}
                      </ul>
                      <div className="border-t py-4">
                        <div className="max-w-lg mx-auto">
                          <p className="text-gray-500 text-sm px-4">
                            Can&#39;t find a date that is suitable to train?
                            Contact us to discuss alternative dates we can set
                            up for you to train
                          </p>
                          <div className="mt-4 px-10 flex flex-col sm:flex-row justify-center items-center relative z-10 rounded-md flex-1">
                            <a
                              href="tel:+443330155117"
                              className="cursor-pointer whitespace-nowrap w-full flex items-center justify-center px-3 py-2 border border-transparent shadow text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 md:mr-4"
                            >
                              Call Us
                            </a>
                            {/* <button
                              type="button"
                              onClick={() => {
                                setShowModal({
                                  ...state,
                                  showCallbackModal: true,
                                });
                              }}
                              className="mt-4 whitespace-nowrap md:mt-0 w-full flex items-center justify-center px-3 py-2 border border-brand-500 shadow text-sm font-medium rounded-md text-brand-600 bg-white hover:bg-gray-100"
                            >
                              Request a callback
                            </button> */}
                            <Link
                              href="/request-a-callback"
                              className="mt-4 whitespace-nowrap md:mt-0 w-full flex items-center justify-center px-3 py-2 border border-brand-500 shadow text-sm font-medium rounded-md text-brand-600 bg-white hover:bg-gray-100"
                            >
                              Request a callback
                            </Link>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-cols-2 grid-cols-3 grid-cols-4"></div>
            </div>
          </div>
        ) : null}
        {blendedCollection.length > 0 && event.events.length <= 3 ? (
          <div
            className={openTab === "blended" ? "block" : "hidden"}
            id="link3"
          >
            <div>
              <div className="relative">
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="max-w-7xl mx-auto text-center prose lg:prose-lg">
                    <p className="text-gray-500   my-3 p-2">
                      Our blended training courses are delivered to students
                      through the use of Zoom webinars and in-person assessment
                      days. Our blended courses are held over two days. You will
                      be required to complete online pre-study, attend the
                      webinar sessions and complete your in-person assessment to
                      obtain your accreditation.
                    </p>

                    <div className="overflow-hidden bg-white shadow sm:rounded-md mb-4 relative max-w-7xl mx-auto not-prose">
                      <ul
                        role="list"
                        className="divide-y divide-gray-200 list-none m-0 p-0"
                      >
                        {blendedCollection &&
                          blendedCollection.map((ev, idx) => (
                            <li key={ev.id} className="m-0 p-0">
                              <button
                                className="block hover:bg-gray-50 w-full focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600"
                                onClick={() => {
                                  session.addCourse({
                                    ...primary,
                                    event,
                                    selectedEvent: ev,
                                  });
                                  setTimeout(() => {
                                    router.push("/checkout");
                                  }, 500);
                                }}
                              >
                                <div className="flex items-center px-4 py-4 sm:px-6">
                                  {ev.seats - ev.registrations.length < 1 ? (
                                    <div></div>
                                  ) : (
                                    <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                                      <div className="truncate text-center">
                                        <div className="flex w-full justify-center items-center">
                                          <CalendarIcon
                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-brand-700"
                                            aria-hidden="true"
                                          />
                                          <p className="truncate font-semibold text-brand-700">
                                            {format(
                                              new Date(ev.date),
                                              "EEEE do MMMM"
                                            )}
                                          </p>
                                        </div>
                                        <div className="mt-2 flex w-full">
                                          <div className="flex items-center text-sm text-gray-500 justify-center w-full md:justify-start">
                                            <p>
                                              {ev.seats -
                                                ev.registrations.length}{" "}
                                              space
                                              {/* Plural. */}
                                              {ev.seats -
                                                ev.registrations.length !==
                                                1 && "s"}{" "}
                                              available
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mt-2 flex-shrink-0 md:mt-0 md:ml-5">
                                        <div className="flex flex-col md:flex-row items-center">
                                          <p className="mb-2 md:mb-0 font-semibold">
                                            {new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "GBP",
                                            }).format(ev.price / 100)}
                                          </p>
                                          <div className="mt-2 md:mt-0 md:ml-4 w-full flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md text-gray-600 bg-gray-50 hover:bg-gray-100 border border-gray-200 hover:shadow transition-all duration-100">
                                            Book
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="hidden md:block md:ml-5 flex-shrink-0">
                                    <ChevronRightIcon
                                      className="h-5 w-5 text-gray-400"
                                      aria-hidden="true"
                                    />
                                  </div>
                                </div>
                              </button>
                            </li>
                          ))}
                      </ul>
                      <div className="border-t py-4">
                        <div className="max-w-lg mx-auto">
                          <p className="text-gray-500 text-sm px-4">
                            Can&#39;t find a date that is suitable to train?
                            Contact us to discuss alternative dates we can set
                            up for you to train
                          </p>
                          <div className="mt-4 px-10 flex flex-col sm:flex-row justify-center items-center relative z-10 rounded-md flex-1">
                            <a
                              href="tel:+443330155117"
                              className="cursor-pointer whitespace-nowrap w-full flex items-center justify-center px-3 py-2 border border-transparent shadow text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 md:mr-4"
                            >
                              Call Us
                            </a>
                            <button
                              type="button"
                              onClick={() => {
                                setShowModal({
                                  ...state,
                                  showCallbackModal: true,
                                });
                              }}
                              className="mt-4 whitespace-nowrap md:mt-0 w-full flex items-center justify-center px-3 py-2 border border-brand-500 shadow text-sm font-medium rounded-md text-brand-600 bg-white hover:bg-gray-100"
                            >
                              Request a callback
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-cols-2 grid-cols-3 grid-cols-4"></div>
            </div>
          </div>
        ) : null}
      </section>
      {/* // )} */}
      <section className="">
        {/* {event.events.length > 3 && (
          <div className="max-w-7xl px-8 mx-auto" id="course-dates">
            <div className="overflow-hidden bg-white shadow sm:rounded-md mb-4 relative lg:max-w-none mx-auto p-4">
              <div className="md:grid md:grid-cols-10 md:gap-x-10">
                <div className="sm:mt-10 text-center sm:col-start-3 sm:col-end-9 md:col-start-2 md:col-end-10 md:col-span-10 md:row-start-1 md:mt-9 lg:col-start-6 lg:col-end-13 landscape:lg:col-start-7 landscape:xl:col-start-6 landscape:xl:pl-12">
                  <div className="flex items-center text-center text-gray-700">
                    <button
                      type="button"
                      className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                      onClick={() => {
                        if (
                          getMonth(new Date()) === getMonth(state.month) &&
                          getYear(new Date()) === getYear(state.month)
                        ) {
                          return false;
                        }
                        setState((s) => {
                          return {
                            ...s,
                            month: subMonths(state.month, 1),
                            days: createDates(
                              startOfMonth(subMonths(state.month, 1)),
                              endOfMonth(subMonths(state.month, 1)),
                              s.selectedDate
                            ),
                          };
                        });
                      }}
                    >
                      <span className="sr-only">Previous month</span>
                      <ChevronLeftIcon
                        className="w-4 xl:w-5"
                        aria-hidden="true"
                      />
                    </button>
                    <div className="flex-auto font-semibold text-sm xl:text-base">
                      {state.month && format(state.month, "MMMM yyyy")}
                    </div>
                    <button
                      type="button"
                      className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                      onClick={() => {
                        setState((s) => {
                          return {
                            ...s,
                            month: addMonths(state.month, 1),
                            days: createDates(
                              startOfMonth(addMonths(state.month, 1)),
                              endOfMonth(addMonths(state.month, 1)),
                              s.selectedDate
                            ),
                          };
                        });
                      }}
                    >
                      <span className="sr-only">Next month</span>
                      <ChevronRightIcon
                        className="w-4 xl:w-5"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <div className="mt-2 grid grid-cols-7 text-center text-xxs xl:text-xs leading-6 text-gray-500">
                    <div>M</div>
                    <div>T</div>
                    <div>W</div>
                    <div>T</div>
                    <div>F</div>
                    <div>S</div>
                    <div>S</div>
                  </div>
                  <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-100 text-xxs xl:text-xs shadow ring-1 ring-gray-200 overflow-hidden">
                    {datesWithEvents &&
                      datesWithEvents.length > 0 &&
                      datesWithEvents?.map((day, dayIdx) => {
                        let invalidDate =
                          day?.date?.getTime() <
                            startOfDay(new Date()).getTime() ||
                          day?.date?.getTime() === undefined;
                        return (
                          <button
                            key={
                              day && day.date
                                ? `-${dayIdx}-${day?.date?.toString()}`
                                : `date-${dayIdx}`
                            }
                            type="button"
                            disabled={invalidDate}
                            onClick={() => {
                              setState((s) => ({
                                ...s,
                                selectedDate: day,
                              }));
                            }}
                            className={classNames(
                              "px-0.5 py-1 xl:px-1 xl:py-3 hover:bg-gray-100 focus:z-10 text-xxs xl:text-sm relative",
                              day?.previous ? "bg-gray-50" : "bg-white",
                              day?.isToday && "font-semibold",
                              invalidDate && "cursor-not-allowed text-gray-400",
                              day?.hasEvent &&
                                "bg-brand-400 hover:bg-brand-200",
                              day?.date?.getTime() ===
                                state.selectedDate?.date?.getTime() &&
                                "!bg-brand-700 !text-white font-semibold"
                            )}
                          >
                            {day &&
                              day.hasEvent &&
                              (state.selectedType === null ? (
                                <div className="flex absolute top-1">
                                  <div
                                    className={classNames(
                                      " w-2 h-2 border p-0.5 rounded-full bg-red-400",
                                      day &&
                                        day?.events.find((x) => {
                                          return x?.type === "onsite";
                                        })
                                        ? ""
                                        : "hidden"
                                    )}
                                  ></div>
                                  <div
                                    className={classNames(
                                      "w-2 h-2 border p-0.5 rounded-full bg-blue-400",
                                      day &&
                                        day?.events.find((x) => {
                                          return x?.type === "virtual";
                                        })
                                        ? ""
                                        : "hidden"
                                    )}
                                  ></div>
                                </div>
                              ) : (
                                <div className="flex absolute top-1">
                                  <div
                                    className={classNames(
                                      "w-2 h-2 border p-0.5 rounded-full",
                                      state.selectedType === "onsite" &&
                                        "bg-red-400",
                                      state.selectedType === "virtual" &&
                                        "bg-blue-400",
                                      day &&
                                        day?.events?.find((x) => {
                                          return x?.type === state.selectedType;
                                        })
                                        ? ""
                                        : "hidden"
                                    )}
                                  ></div>
                                </div>
                              ))}
                            <time
                              dateTime={
                                day && day.date && day.date.toISOString()
                              }
                              className={classNames(
                                "mx-auto flex items-center justify-center rounded-full py-1 text-sm md:text-base"
                              )}
                            >
                              {day.date && format(day.date, "dd")}
                            </time>
                          </button>
                        );
                      })}
                  </div>
                  <div className="flex justify-evenly m-2 ">
                    <button
                      onClick={() => {
                        setState((s) => ({
                          ...s,
                          selectedType: "onsite",
                        }));
                      }}
                      className="flex items-center text-center"
                    >
                      <div className="w-2 h-2 m-2 rounded-full bg-red-400 border"></div>
                      <p className="text-xs">On Site</p>
                    </button>
                    <button
                      onClick={() => {
                        setState((s) => ({
                          ...s,
                          selectedType: "virtual",
                        }));
                      }}
                      className="flex items-center text-center"
                    >
                      <div className="w-2 h-2 m-2 rounded-full bg-blue-400 border"></div>
                      <p className="text-xs">Virtual</p>
                    </button>
                    <button
                      onClick={() => {
                        setState((s) => ({
                          ...s,
                          selectedType: null,
                        }));
                      }}
                      className="flex items-center justify-start text-center"
                    >
                      <div className="w-2 h-2 m-2 rounded-full bg-black border"></div>
                      <p className="text-xs">Show All</p>
                    </button>
                  </div>
                </div>
                <ol className="mt-4 divide-y divide-gray-100 text-sm leading-6 sm:col-start-2 sm:col-end-10 lg:col-start-3 lg:col-end-9 lg:col-span-6 xl:col-span-5 landscape:lg:row-start-1 landscape:lg:col-start-1 landscape:lg:col-end-7 landscape:xl:col-end-6 xl:mt-8">
                  <h2 className="text-lg sm:text-xl font-semibold text-gray-900 md:mb-4 md:text-center lg:text-left mt-8 md:mt-0">
                    {event.events && event.events[0]?.detail?.title} -{" "}
                    {state.selectedDate &&
                      format(state?.selectedDate?.date, "do MMMM yyyy")}
                  </h2>
                  {filteredEvents && filteredEvents.length > 0 ? (
                    filteredEvents.map((event) => {
                      console.log(
                        "events",
                        event,
                        event.seats - event.registrations.length
                      );
                      return (
                        <li
                          key={event.id}
                          className="relative bg-white sm:p-4 rounded-md sm:flex sm:space-x-6 pt-3 pb-3 sm:pb-0 sm:pt-6 sm:static"
                        >
                          <div className="sm:mt-0 flex-auto sm:text-start sm:pr-0 sm:pb-2">
                            <h3 className="pr-10 text-base pt-1 font-medium sm:font-semibold text-gray-900 sm:pr-0 flex justify-between">
                              {event.detail.title}
                              <span>{currency(event.price)}</span>
                            </h3>
                            <dl className="mt-2 flex flex-col text-gray-500 sm:flex-row">
                              <div className="flex flex-row-reverse sm:flex-row justify-end sm:justify-start items-center sm:space-x-3 flex-1 mb-4 sm:mb-0">
                                <div className="flex items-center ml-4 sm:ml-0">
                                  <dt className="mt-0.5 mr-1">
                                    <span className="sr-only">Date</span>
                                    <CalendarIcon
                                      className="h-4 w-4 text-gray-400"
                                      aria-hidden="true"
                                    />
                                  </dt>
                                  <dd className="sm:w-24">
                                    <time
                                      dateTime={event.date}
                                      className="text-xs"
                                    >
                                      {format(new Date(event.start), "ha")} -{" "}
                                      {format(new Date(event.end), "ha")}
                                    </time>
                                  </dd>
                                </div>
                                {event?.event_resources &&
                                event?.event_resources[0]?.user?.user_assets[0]
                                  ?.asset?.url &&
                                event?.event_resources[0]?.user?.user_assets[0]
                                  ?.asset?.url.length > 0 ? (
                                  <div className="flex items-center">
                                    <img
                                      src={
                                        event.event_resources[0]?.user
                                          ?.user_assets[0]?.asset?.url
                                      }
                                      alt="Tutor"
                                      className="flex h-8 w-8 self-center flex-none rounded-full mr-2 sm:mx-4"
                                    />
                                    <p>
                                      {
                                        event.event_resources[0]?.user
                                          .given_name
                                      }
                                    </p>
                                  </div>
                                ) : null}
                              </div>
                              {event.seats - event.registrations.length < 1 ? (
                                <div></div>
                              ) : (
                                <div className="flex sm:justify-end sm:items-center mb-2 sm:mb-0 sm:mt-0">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      session.addCourse({
                                        ...primary,
                                        event: { events: state.monthEvents },
                                        selectedEvent: event,
                                      });
                                      setTimeout(() => {
                                        router.push("/checkout");
                                      }, 500);
                                    }}
                                    className="items-center w-full sm:w-auto justify-center px-6 py-2 m-0 border border-transparent rounded-md shadow text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 "
                                  >
                                    Enrol
                                  </button>
                                </div>
                              )}
                            </dl>
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-1">
                                <div
                                  className={classNames(
                                    "h-3 w-3 rounded-full",
                                    event.type === "onsite" && "bg-red-400",
                                    event.type === "virtual" && "bg-blue-400"
                                  )}
                                ></div>
                                <div className="text-gray-400">
                                  {(event.type === "onsite" && "On Site") ||
                                    (event.type === "virtual" && "Virtual")}
                                </div>
                              </div>
                              {event.seats - event.registrations.length < 1 ? (
                                <div>Course Full</div>
                              ) : (
                                <div className="text-gray-500 ml-6">
                                  {" "}
                                  {event.seats -
                                    event.registrations.length}{" "}
                                  Space
                                  {event.seats - event.registrations.length !==
                                    1 && "s"}{" "}
                                  Available
                                </div>
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <div className="text-center py-12 lg:flex lg:flex-col lg:justify-center lg:items-center lg:h-full lg:pb-28">
                      <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          vectorEffect="non-scaling-stroke"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        />
                      </svg>
                      <h3 className="mt-2 text-sm font-medium text-gray-900">
                        {state.selectedDate
                          ? "No training courses scheduled for this date"
                          : "No date selected"}
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        {state.selectedDate
                          ? "Select a different date to view courses"
                          : "Select a date to see the courses available"}
                      </p>
                    </div>
                  )}
                </ol>
              </div>
              <div className="border-t py-4">
                <div className="max-w-lg mx-auto">
                  <p className="text-gray-500 text-sm px-4">
                    Can&#39;t find a date that is suitable to train? Contact us
                    to discuss alternative dates we can set up for you to train
                  </p>
                  <div className="mt-4 px-10 flex flex-col sm:flex-row justify-center items-center relative z-1 rounded-md flex-1">
                    <a
                      href='tel:+443330155117'
                      className="cursor-pointer whitespace-nowrap w-full flex items-center justify-center px-3 py-2 border border-transparent shadow text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 md:mr-4"
                    >
                      Call Us
                    </a>
                    <button
                      type="button"
                      onClick={() => {
                        setShowModal({ ...state, showCallbackModal: true });
                      }}
                      className="mt-4 sm:mt-0 sm:ml-2 md:ml-0 whitespace-nowrap md:mt-0 w-full flex items-center justify-center px-3 py-2 border border-brand-500 shadow text-sm font-medium rounded-md text-brand-600 bg-white hover:bg-gray-100"
                    >
                      Request a callback
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}
      </section>
      {showModal.showCallbackModal && (
        <CallbackModal
          event={event}
          entry={primary}
          showCallbackModal={showModal.showCallbackModal}
          setShow={setShowModal}
        />
      )}
    </div>
  );
}
